import { useGuestBooking } from "@/components/pages/Guest/GuestBookingContext";
import { useAppSelector } from "@/redux/hooks";
import { selectBookingPassenger, selectGuestContact } from "@/redux/slices/clientBooking/selectors";
import { useAccountHolder } from "./useAccountHolder";

/**
 * The main passenger (Passenger 1), derived live from "Who is this booking for?" — the account holder
 * by default, a chosen guest, or (guest flow) the guest themselves. Mirrors the Other Details panel's
 * locked Passenger #1 so the Booking Summary can show it without waiting for an explicit Proceed and
 * keep it in sync when the selection changes. `name` is "" until a name is known (e.g. profile still
 * loading), so callers can hide the row.
 */
export const useMainPassenger = (): { name: string; phone: string } => {
  const { isGuest } = useGuestBooking();
  const passenger = useAppSelector(selectBookingPassenger);
  const guestContact = useAppSelector(selectGuestContact);
  const accountHolder = useAccountHolder();

  if (isGuest) {
    return { name: `${guestContact?.firstName ?? ""} ${guestContact?.lastName ?? ""}`.trim(), phone: guestContact?.phone ?? "" };
  }
  // A chosen guest/favourite passenger; otherwise (null or "self") the account holder — the managed
  // client under operator/EA scope, the logged-in user in self-service.
  if (passenger && passenger.kind !== "self") {
    return { name: `${passenger.firstName} ${passenger.lastName}`.trim(), phone: passenger.phone ?? "" };
  }
  return { name: `${accountHolder.firstName} ${accountHolder.lastName}`.trim(), phone: accountHolder.mobile };
};
